import { memo } from "react";
import styled from "styled-components";
import { PiTrash, PiMagnifyingGlass, PiPen } from "react-icons/pi";
import { Element_Base } from "~/common/typescript/models/Element";
import { useAtom } from 'jotai';
import { elementsAtom } from "~/components/Map/Element/ElementStore";
import { ElementItemUtil } from "./ElementItemUtil";
import { Popconfirm } from "antd";
import { CommentAPIs } from "~/common/typescript/apis/CommentAPIs";
import { ElementAPIs } from "~/common/typescript/apis/ElementAPIs";

type ElementItemContextMenuProps = {
  element: Element_Base;
  onClickEdit: Function;
  onCloseContextMenu: Function;
}
const ElementItemContextMenu = (props: ElementItemContextMenuProps) => {
  const [elements, setElements] = useAtom<Element_Base[]>(elementsAtom);

  const onClick_Delete = async () => {
    await ElementAPIs.remote_delete(props.element.uuid!);
    setElements(
      elements.map((element: Element_Base) => {
        if (element.uuid === props.element.uuid) {
          return {
            ...element,
            is_deleted: true,
          };
        }
        return element;
      })
    );
    props.onCloseContextMenu();
  }

  const onClick_Edit = () => {
    props.onClickEdit();
    props.onCloseContextMenu();
  }

  const onClick_ZoomTo = () => {
    ElementItemUtil.zoomToElement(props.element);
    props.onCloseContextMenu();
  }

  return <UI_Wrapper className="map-view-panel">
    <UI_List>

      {/* Chỉnh sửa */}
      <UI_Item onClick={onClick_Edit}>
        <UI_Item_Icon>
          <PiPen />
        </UI_Item_Icon>
        <UI_Item_Text>Chỉnh sửa</UI_Item_Text>
        <UI_Item_Value>
          {/* Insert */}
        </UI_Item_Value>
      </UI_Item>
      {/* End chỉnh sửa */}

      {/* Xoá */}
      <Popconfirm
        placement="top"
        title="Xoá"
        description="Bạn có chắc chắn muốn xoá?"
        okText="Xoá"
        cancelText="Huỷ"
        onConfirm={onClick_Delete}
      >
        <UI_Item>
          <UI_Item_Icon>
            <PiTrash />
          </UI_Item_Icon>
          <UI_Item_Text>Xoá</UI_Item_Text>
          <UI_Item_Value>
            {/* Delete */}
          </UI_Item_Value>
        </UI_Item>
      </Popconfirm>
      {/* End Xoá */}

      {/* Zoom to */}
      <UI_Item onClick={onClick_ZoomTo}>
        <UI_Item_Icon>
          <PiMagnifyingGlass />
        </UI_Item_Icon>
        <UI_Item_Text>Phóng tới</UI_Item_Text>
        <UI_Item_Value>
          {/* F */}
        </UI_Item_Value>
      </UI_Item>
      {/* End Zoom to */}
    </UI_List>

  </UI_Wrapper>
}

export default memo(ElementItemContextMenu);

const UI_Wrapper = styled.div`
  border-radius: 8px;
  width: 250px;
  background-color: rgba(255,255,255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
`;

const UI_List = styled.div`
  display: flex;
  flex-direction: column;
`
const UI_Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
`
const UI_Item_Icon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
`

const UI_Item_Text = styled.div`
  flex: 1;
  font-size: 14px;
`
const UI_Item_Value = styled.div`
  padding: 8px;
  width: 80px;
  font-size: 14px;
  text-align: right;
  padding-right: 12px;
`
const UI_Item_Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #eaeaea;
`